var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAlign = function SvgAlign(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46447 3.82843L9.64645 0.646446C9.84171 0.451185 10.1583 0.451185 10.3536 0.646446L13.5355 3.82843C13.7308 4.02369 13.7308 4.34027 13.5355 4.53553C13.3403 4.7308 13.0237 4.7308 12.8284 4.53553L10.5 2.20711V10H9.5V2.20711L7.17157 4.53553C6.97631 4.7308 6.65973 4.7308 6.46447 4.53553C6.2692 4.34027 6.2692 4.02369 6.46447 3.82843Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5355 23.1716L10.3536 26.3536C10.1583 26.5488 9.84171 26.5488 9.64645 26.3536L6.46447 23.1716C6.2692 22.9763 6.2692 22.6597 6.46447 22.4645C6.65973 22.2692 6.97631 22.2692 7.17157 22.4645L9.5 24.7929V17H10.5V24.7929L12.8284 22.4645C13.0237 22.2692 13.3403 22.2692 13.5355 22.4645C13.7308 22.6597 13.7308 22.9763 13.5355 23.1716Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13H20V14H0V13Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlign, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/align.bb4d6275.svg";
export { ForwardRef as ReactComponent };